'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'party-horn';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e31b';
var svgPathData = ['M18.5 475.9l17.7 17.7 92.8-33.3-77.1-77.1-33.3 92.8zM57.8 366.4l87.8 87.8 77.5-27.8-137.5-137.5-27.8 77.5zm33.8-94.2l2.1 2.1 144 144 2.1 2.1 75.1-27-196.3-196.3-27 75.1z', 'M64 48a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM64 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64.9 460.2l-77.1-77.1-33.3 92.8 17.7 17.7 92.8-33.3zm16.7-6l77.5-27.8-137.5-137.5-27.8 77.5 87.8 87.8zm94.2-33.8l75.1-27-196.3-196.3-27 75.1 2.1 2.1 144 144 2.1 2.1zM32 512L0 480 106 184.7 112 168 344 400 327.4 406 32 512zM496 160a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 304a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM469.7 53.7l-19 19C440.8 82.5 427.5 88 413.6 88l-11 0c-19.4 0-33.1 19-27 37.5 9.6 28.8-11.8 58.5-42.2 58.5l-11 0c-9.7 0-18.9 3.8-25.7 10.7-14.9 14.9-23.1 23.1-24.7 24.7L260.7 208c1.5-1.5 9.8-9.8 24.7-24.7 9.8-9.8 23.2-15.3 37.1-15.3l11 0c19.4 0 33.1-19 27-37.5-9.6-28.8 11.8-58.5 42.2-58.5l11 0c9.7 0 18.9-3.8 25.7-10.7 14.9-14.9 23.1-23.1 24.7-24.7l11.3 11.3-5.7 5.7zM232 24l0 32.2c0 27.6-11 54-30.5 73.5L176 155.3 164.7 144c1.4-1.4 9.9-9.9 25.5-25.5 16.5-16.5 25.8-38.9 25.8-62.2l0-32.2 16 0zM480 280l8 0 0 16-32.2 0c-23.3 0-45.7 9.3-62.2 25.8-15.6 15.6-24.1 24.1-25.5 25.5L356.7 336c1.4-1.4 9.9-9.9 25.5-25.5 19.5-19.5 46-30.5 73.5-30.5l24.2 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPartyHorn = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;